import axios from 'axios';
import {AxiosResponse} from 'axios';
import {APIResponse} from './baseResponse';

const nusaInstance = axios.create({
  // baseURL: "http://localhost/nusa-backend/",
  baseURL: 'https://api.nusa.finance/',
});

export const registerNft = async (data: {
  nft_id: number;
  nft_token_id: string;
  nft_name: string;
  wallet_address: string;
  user_name: string;
  user_email: string;
  user_phone: string;
}) => {
  return nusaInstance
    .post(`api/register_nft`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response: AxiosResponse<APIResponse<any>>) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
};

export const votingNftStats = async (eventId: number) => {
  return nusaInstance
    .get(`api/voting_nft_stats/${eventId}`)
    .then((response: AxiosResponse<APIResponse<any>>) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
};

export const voteNft = async (data: {voteMessage: any; address: string; signature: string}) => {
  return nusaInstance
    .post(`api/voting_nft_vote`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response: AxiosResponse<APIResponse<any>>) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
};
